import * as React from "react";
const SvgStop = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", height: 24, viewBox: "0 0 24 24", width: 24, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M6 6h12v12H6z" }));
export default SvgStop;
